import {Link} from 'gatsby';
import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import * as headerStyles from '../Styles/header.module.scss';
import {useStaticQuery, graphql} from 'gatsby';
import {KeyValuePair} from '../../Application/Shared';
import AssetsService from '../../Application/Shared/AssetsService';
import {Container} from 'react-bootstrap';
import * as utils from './Utils';
import cookie from 'react-cookies';
import Search from '../../Templates/Shared/Search';

export const headerData = () => {
  const data = useStaticQuery(
      graphql`
      query FacultyList {
        allBrandWebsiteCoursepages(sort: {order: ASC, fields: [menuorder]}) {
          nodes {
            url
            title
            graduates
            rating
            courseslug
            reference {
              facultyslug
            }
            publish_details {
              locale
            }
            coursemenuname
          }
        }
        allBrandWebsiteFacultypage(sort: {order: ASC, fields: [facultyorder]}) {
          edges {
            node {
              title
              facultyslug
              url
              publish_details {
                locale
              }
            }
          }
        }
      }
    `,
  );
  return data;
};


/**
 *
 *
 * @param {*} {locale, headerContent}
 * @return {*}
 */
const Header = ({locale, headerContent, isHomepage = false,
  isCatalogueSearch}) => {
  const {allBrandWebsiteCoursepages: {nodes: courseData}}=headerData();
  const {allBrandWebsiteFacultypage}=headerData();
  const facultyData = allBrandWebsiteFacultypage.edges;
  const squareAssetsService = new AssetsService('WEBSITE_SQUARE');
  const [scroll, setScroll] = useState(false);


  const labelValues = headerContent.texts.value;
  const labels = new KeyValuePair(labelValues);
  const catalogpageURL =utils.
      getLocalizedPageLink(locale, headerContent.courses[0].url);

  const handleClickOutside = (event) => {
    if ((dropdownRef.current &&
      !dropdownRef.current.contains(event.target)) ||
      (drodownCloseRef.current &&
      drodownCloseRef.current.contains(event.target))) {
      triggerDropdown(false);
      revertDropdownContent(event);
    }
  };
  const listenScrollevent = () => {
    if (window.scrollY > 50) {
      setScroll(true);
    } else if (window.scrollY <= 50) {
      setScroll(false);
    }
  };

  useEffect(() => {
    if (window.innerWidth < 640) {
      setFacultyDropdownState('');
    }
    document.addEventListener('click', handleClickOutside, true);
    window.addEventListener('scroll', listenScrollevent);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
      window.removeEventListener('scroll', listenScrollevent, true );
    };
  }, []);

  const revertDropdownContent = (e) => {
    e.stopPropagation();
    triggerDropdown(false);
    if (window.innerWidth < 640) {
      setFacultyDropdownState('');
    }
  };
  /**
   *
   *
   * @param {*} data
   * @return {*}
   */
  const filterLocaleBasedData = (data) => {
    const filteredData = data.filter((node) =>
      node.publish_details.locale === locale);
    return filteredData;
  };

  /**
   *
   *
   * @param {*} facultyData
   * @return {*}
   */
  const getFaculties = (facultyData) => {
    const filteredFaculties = facultyData
        .filter(({node}) => node.publish_details.locale === locale);
    const facultyMap={};
    filteredFaculties.forEach((faculty) => {
      facultyMap[faculty.node.facultyslug]=faculty.node;
    });
    return facultyMap;
  };

  /**
   *
   *
   * @param {*} courseData
   * @param {*} facultyData
   * @return {*}
   */
  const segregateCourses = (courseData, facultyData) => {
    const facultyMap = {};
    Object.keys(facultyData).forEach((faculty) => {
      facultyMap[faculty]={...facultyData[faculty]};
      facultyMap[faculty].courseList = [];
      courseData.forEach((course) => {
        course?.reference?.forEach((ref) => {
          if (ref.facultyslug.toLowerCase() === faculty) {
            const data = {
              title: course.title,
              url: utils.getLocalizedPageLink(locale, course.url),
              menuName: course.coursemenuname,
              rating: course.rating,
              graduates: course.graduates,
              slug: course.courseslug,
            };
            facultyMap[faculty].courseList.push(data);
          }
        });
      });
    });
    return Object.keys(facultyMap)
        .map((ele) => (facultyMap[ele]));
  };

  const getFirstFaculty = (facultyList) => {
    let firstFaculty='';
    firstFaculty=facultyList.filter((faculty) => {
      return faculty.courseList.length;
    })[0]?.facultyslug;
    return firstFaculty;
  };

  const facultyMap = getFaculties(facultyData);
  const filteredCourseData = filterLocaleBasedData(courseData);
  const facultyList = segregateCourses(filteredCourseData, facultyMap);
  const [showDropdown, triggerDropdown] = useState(false);
  const firstFaculty=getFirstFaculty(facultyList);

  const [showFaculty, setFacultyDropdownState] = useState(firstFaculty);
  const dropdownRef = useRef();
  const drodownCloseRef = useRef();
  const signupUrl = '/courses/';
  const homePageLink = utils.getLocalizedPageLink(locale, '/');
  const loggedIn=cookie.load('student_id');
  const localeSub = ['en', 'en-in', 'en-ng'].includes(locale) ?
  'en' : locale;
  // const countryCode = cookie.load('geotargetly_country_code');

  return (
    <>
      <header
        className={`${headerStyles.header}
        ${isHomepage && scroll ? headerStyles.headerScroll : '' }
        ${!isHomepage ? headerStyles.headerScroll : ''}
        ${headerStyles.headerx}`}
        style={{
          background: isHomepage && !scroll ? 'transparent' : '#fff',
          boxShadow: isHomepage && !scroll ?
           'none' : '0 0 30px 0 rgba(0, 0, 0, 0.03)',
          padding: isHomepage ? '34px 0' : '16px 0',
        }}
      >
        <Container className={headerStyles.container}>
          <div className={headerStyles.headerTopSection}>
            <div className={headerStyles.headerLogo}>
              <Link to={homePageLink}>
                <img src="/images/logo/header-logo.svg"
                  alt="brand" width="201" height="36"
                  className={headerStyles.desktopLogo}/>
                <img src="/images/logo/logo-mobile.svg"
                  alt="brand" width="130" height="24"
                  className={headerStyles.mobileLogo}/>
              </Link>
              <div className={headerStyles.mobileSearch}>
                <div className={headerStyles.showOnMobile}>
                  {process.env.showSearchOnHomePage === 'true' &&
                    <Search
                      isCatalogueSearch={true}
                      isHomepage={isHomepage}/>
                  }
                </div>
                <div className={`${headerStyles.dropdownTrigger
                } library-brand-icon-new`}
                onClick={() => triggerDropdown(true)}>
                  <p className={headerStyles.hideOnMobile}>Courses</p>
                  <i className={`${headerStyles.hideOnMobile
                  } icon-new-down-filled`}></i>
                  <img className={headerStyles.showOnMobile}
                    alt="Hamberger"
                    src="/images/logo/hamburger.png" width="29"
                    height="23"/>
                </div>
              </div>
            </div>
            <div className={headerStyles.hideOnMobile}>
              {process.env.showSearchOnHomePage === 'true' &&
                <Search
                  isCatalogueSearch={true}
                  isHomepage={isHomepage}/>
              }
            </div>
            <div className={headerStyles.headerContent}>
              <a className={headerStyles.enterpriseCta}
                href="https://www.upskillist.pro/?utm_medium=referral&utm_source=upskillist.com&utm_campaign=website_header_cta" target="_blank"
                rel="external noreferrer">
                {headerContent.slogan}
              </a>
              <Link to={`/learner/${localeSub}/login/`}
                className={ `${headerStyles.loginCta} ${
                  loggedIn ? headerStyles.showLoginCtaOnMobile : ''}`}>
                {labels.getValue('LOGIN_CTA')}
              </Link>
              <Link to={signupUrl}
                className={headerStyles.signUpCta}
                rel="noindex nofollow">
                {/* {countryCode=='us' ? 'Enroll Now' :
                          `${ labels.getValue('SIGNUP_CTA')}`} */}
                { labels.getValue('SIGNUP_CTA')}

              </Link>

            </div>
            {/* Dropdown goes here */}
            {showDropdown && (
              <div
                ref={dropdownRef}
                className={headerStyles.dropdown}>
                <div className=
                  {`${headerStyles.catalogueHeader} ${
                    showFaculty ? headerStyles.hideOnMobile : ''
                  } library-brand-icon-new`}>
                  <div className={headerStyles.catalogueDropdownTitle}>
                    <p>{headerContent.dropdownheading}</p>
                  </div>
                  <i className={`icon-new-close ${
                    headerStyles.dropdownHeaderClose}`}
                  onClick={revertDropdownContent}/>
                  <div
                    className={`${headerStyles.viewCatalogueCta} ${
                      headerStyles.hideOnMobile}`}>
                    <Link to={catalogpageURL}>
                      {labels.getValue('VIEW_FULL_CATALOGUE_CTA')}
                    </Link>
                  </div>
                </div>
                <div className={headerStyles.catalogueContent}>
                  <div className={`${headerStyles.catalogueFacultySection} ${
                    showFaculty ? headerStyles.hideOnMobile : ''}`}>
                    <ul>
                      {facultyList.map((faculty, index) =>
                      faculty.courseList.length ? (
                        <li className={`${showFaculty === faculty.facultyslug ?
                              headerStyles.active : ''}`} key={index}
                        onClick={() =>
                          setFacultyDropdownState(faculty.facultyslug)}>
                          <a className={headerStyles.facultyNameSection}>
                            <div
                              className=
                                {`${headerStyles.facultyIcon
                                } library-brand-icon`}>
                              {/* <i className={`icon-${faculty.facultyslug}`}>
                              </i> */}
                            </div>
                            <div className={headerStyles.facultyName}>
                              {faculty.title}
                            </div>
                          </a>
                          <div
                            className={`library-brand-icon-new ${
                              headerStyles.arrow}`}>
                            <i className="icon-new-right-arrow"></i>
                          </div>
                        </li>
                      ):'') }
                    </ul>
                    <div className={`${headerStyles.viewCatalogueCta}`}>
                      <Link to={catalogpageURL}>
                        {labels.getValue('VIEW_FULL_CATALOGUE_CTA')}
                      </Link>
                    </div>
                  </div>
                  <div className={`${headerStyles.catalogueCoursesSection} ${
                    !showFaculty ? headerStyles.hideOnMobile : ''}`}>
                    {facultyList.map((faculty, index) => {
                      const facultyURL =utils.
                          getLocalizedPageLink(locale, faculty.url);
                      let count=0;
                      return ((showFaculty === faculty.facultyslug) &&
                          <div className={headerStyles.catalogueCoursesInner}
                            key={index}>
                            <div
                              className={`${headerStyles.facultyHeader
                              } library-brand-icon-new`}
                              onClick={() => setFacultyDropdownState(null)}>
                              <i
                                className={`${headerStyles.backArrow
                                } icon-new-back-arrow`}>
                              </i>
                              <div className={`${headerStyles.facultyIcon
                              } library-brand-icon`}>
                                {/* <i
                                  className={`icon-${faculty.facultyslug}`}
                                >
                                </i> */}
                              </div>
                              <span>{faculty.title}</span>
                            </div>
                            <div className={headerStyles.facultyCourseCount}>
                              {faculty.courseList.length} Courses</div>
                            {/* <div className=
                            "faculty-dropdown-section-mobile">
                              <div className="faculty-dropdown-title">
                                <span>{faculty.title}</span>
                              </div>
                              <img className="dropdown-header-close"
                                onClick={() => setFacultyDropdownState(null)}
                                src=
                                  "/images/home/new/dropdown/dropdown-close.svg"
                                alt="" />
                            </div> */}
                            <div className={headerStyles.courseList}>
                              {faculty.courseList.map((course, index) => {
                                const squareImage=
                                squareAssetsService.fetchAssetURL(course.slug);
                                count=count+1;
                                if (count<=8) {
                                  return (<Link to={course.url}
                                    className={headerStyles.course}
                                    key={index}>
                                    <div className={headerStyles.courseImg}>
                                      <img src={squareImage}
                                        alt={course.tile} />
                                    </div>
                                    <div className={headerStyles.courseContent}>
                                      <h5>
                                        {course.menuName
                                            .replace(/(.{35})..+/, '$1…')}
                                      </h5>
                                      <div className={headerStyles.courseInfo}>
                                        <p
                                          className={
                                            headerStyles.graduatesCount}>
                                          {course.graduates?.toLocaleString()}
                                      &nbsp;
                                          {labels.getValue('GRADUATES_TEXT')}
                                        </p>
                                        <div
                                          className={`${
                                            headerStyles.courseRating
                                          } library-brand-icon`}>
                                          <p>{course.rating/10}</p>
                                          <i className="icon-star-filled"></i>
                                        </div>
                                      </div>
                                    </div>
                                  </Link>);
                                }
                              })}
                            </div>
                            <div className={headerStyles.facultyLinkSection}>
                              <span>
                                {faculty.courseList.length>8 ?
                               faculty.courseList.length-8: 0 }
                              &nbsp;
                                {labels.getValue('MORE_COURSES_AVAILABLE_TEXT')}
                              </span>
                              <Link to={facultyURL}
                                className="library-brand-icon-new">
                                {labels.getValue('VIEW_ALL_CTA')}
                                <i className="icon-new-right-arrow"></i>
                              </Link>
                            </div>
                          </div>);
                    })}
                  </div>
                </div>
              </div>
            )}
          </div>
        </Container>
      </header>
    </>
  );
};

Header.defaultProps = {
  data: {},
};

Header.propTypes = {
  data: PropTypes.object,
  locale: PropTypes.string,
  cataloguePageURL: PropTypes.string,
  headerContent: PropTypes.object,
  isHomepage: PropTypes.bool,
  isCatalogueSearch: PropTypes.bool,
};
export default Header;
